import React from 'react'
import DatePicker from 'react-datepicker';
import { Field, ErrorMessage } from 'formik';
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import id from "date-fns/locale/id";

class DatePicChild extends React.Component {

    render() {
     
        const { name, onChange, showTime, value, maxDate, minDate, errors, touched, disabled, placeholderText, showYearPicker = false,  showMonthYearPicker = false, dateFormat = "dd/MM/yyyy", isClearable = false } = this.props
        return (<div >
            <Field name={name}
                render={({ field }) => (
                    <DatePicker
                        {...field}
                        locale={id}
                        className={`form-control d-block ${(errors && touched ? ' is-invalid' : '')}`}
                        selected={value}
                        onChange={onChange}
                        dateFormat={dateFormat}
                        disabled={disabled ? true : false}
                        showTimeInput={showTime}
                        minDate={minDate ? minDate : null}
                        maxDate={maxDate ? maxDate : null}
                        placeholderText={placeholderText ? placeholderText : ''}
                        popoverAttachment='bottom right'
                        popoverTargetAttachment='top right'
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        showMonthYearPicker={showMonthYearPicker}
                        showYearPicker={showYearPicker}
                        isClearable={isClearable}
                    />
                )}
            />
            <ErrorMessage
                name={name}
                component="div" style={{ color: 'red' }}
                className="invalid-feedback" />
        </div>
        )
    }
}

function compare({ is_notmemo, ...prevProps }, { is_notmemo: n, ...nextProps }) {
    if (is_notmemo && n) {
        return false
    }
    return _.isEqual(_.omit({ ...prevProps }, _.functions({ ...prevProps })), _.omit({ ...nextProps }, _.functions({ ...nextProps })))
}

const DatePic = React.memo(DatePicChild, compare);

export { DatePic }